import { CalendarDate } from "@sp-crm/core";
import { CalendarDateInput } from "components/ui/calendar-date";
import * as React from "react";
import { InDepthQuestionProps } from "./props";

export class DateQuestion extends React.Component<InDepthQuestionProps, undefined> {
    constructor(props: InDepthQuestionProps) {
        super(props);
        this.updateAnswer = this.updateAnswer.bind(this);
    }

    updateAnswer(newVal: CalendarDate | null): void {
        this.props.requestAnswerModification(a => {
            a.dateAnswer = newVal ? newVal.toString() : undefined;
        });
    }

    title(): string {
        return this.props.question.title;
    }

    render(): JSX.Element {
        return (
            <CalendarDateInput
                onChange={this.updateAnswer}
                initial={
                    this.props.answer.dateAnswer
                        ? CalendarDate.parse(this.props.answer.dateAnswer).getOrElse(null)
                        : null
                }
                key={this.props.question.id}
                label={this.title()}
            />
        );
    }
}
